import {
  FilterableSelect,
  type FilterableSelectProps,
} from "carbon-react/esm/components/select";

export { Option } from "carbon-react/esm/components/select";

export function SearchableSelect({
  noResultsMessage = "No matching options",
  ...props
}: FilterableSelectProps) {
  return <FilterableSelect noResultsMessage={noResultsMessage} {...props} />;
}